module.exports = __webpack_public_path__ + "static/media/pomodoro-clock.cf1fd6bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/projects/pomodoro-clock.png
// module id = 213
// module chunks = 0